export default "__VITE_ASSET__BErEYbnw__"